module.exports = __webpack_public_path__ + "img/stamp_white.911dee51.svg";